import styled from 'styled-components';

export const Form = styled('form')(({ theme }) => ({
	display: 'flex',
	flexDirection: 'row',
	flexWrap: 'wrap',
	marginRight: 24,
	marginBottom: 24,
}));
